import React, { ReactElement, CSSProperties } from "react";
import styles from "./LinkButton.module.css";

interface ButtonProps {
  /**
   * Custom class name to be added to the button
   */
  className?: string;
  id?: string;
  /**
   * Content of the button
   */
  children: string | ReactElement;
  /**
   * A11y name to apply to the button
   */
  name: string;
  /**
   *  Function to call on click
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  /**
   * Is the button disabled
   */
  disabled?: boolean;
  /**
   * Add additional styles
   */
  style?: CSSProperties;
  isIcon?: boolean;
  type?: "submit" | "reset" | "button"
}

const Button: React.FC<ButtonProps> = ({
  className,
  id,
  name,
  onClick,
  disabled,
  children,
  style,
  isIcon,
  ...rest
}): ReactElement => {
  return (
    <button
      {...rest}
      className={`${styles.link} ${isIcon ? styles.icon : ""}  ${className}`}
      id={id}
      onClick={onClick}
      name={name}
      style={{ ...style }}
    >
      {children}
    </button>
  );
};

export default Button;
